import React, { Component } from "react";
import axios from "../../util/axios";
import ApplicationsTable from "../../components/snapshotdatamanagement/ApplicationsTable";
import Filter from "../../components/Filter";
import { trackPromise } from "react-promise-tracker";
import { Link } from "react-router-dom";
import moment from "moment";
import Search from "../../components/Search";
import Timezone from "../../components/common/Timezone";
import CobrandSelector from "../../components/cobrandselection/CobrandSelector";

class Applications extends Component {
  getCobrandById(cobrandId) {
    var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
    var index = cobrands.findIndex(function(cobrand, i) {
      return cobrand.id.toString() === cobrandId;
    });
    return index > -1 ? cobrands[index] : cobrands[0];
  }

  state = {
    initialLoaded: false, /* Temporary fix for spinner loading */
    applications: [],
    searchTerm: "",
    totalCount: 0,
    rowsPerPage: 50,
    filter: false,
    cobrand: this.props.match
      ? this.getCobrandById(this.props.match.params.cobrandId)
      : JSON.parse(localStorage.getItem("userData")).cobrands[0],
    searchCriteria: "",
    noDataAvailable: false
  };

  componentDidMount() {
    //if (this.props.location && this.props.location.state) {
    //this.setState({ applications: this.props.location.state });
    //} else {
    const modifiedParams = {};
    let fromDate = moment()
      .subtract(6, "d")
      .format("MM-DD-YYYY");
    let toDate = moment().format("MM-DD-YYYY");
    var fromDateToconvert = moment(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    var toDateToconvert = moment(toDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    modifiedParams.fromDate = moment.utc(moment(fromDateToconvert)).format();
    modifiedParams.toDate = moment.utc(moment(toDateToconvert)).format();
    trackPromise(
      axios
        .get(`/api/applications?skip=0&top=${this.state.rowsPerPage}`, {
          params: modifiedParams,
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrand.id
          }
        })
        .then(res => {
          this.setState({
            applications: res.data.application,
            totalCount: res.data.totalCount
          });
          let defaultFromDate = moment()
            .subtract(6, "d")
            .format("MM-DD-YYYY");
          let defaultToDate = moment().format("MM-DD-YYYY");
          let searchCriteria =
            "Search results for From date: " +
            defaultFromDate +
            " and To Date: " +
            defaultToDate;
          this.setState({ searchCriteria, noDataAvailable: false, initialLoaded: true }); /* Temporary fix for spinner loading */
          //this.props.history.push(
          //this.props.location.pathname,
          //this.state.applications
          //);
        })
        .catch(err => {
          this.setState({ initialLoaded: true }); /* Temporary fix for spinner loading */
          console.log(err);
        })
    );
    //}
  }

  async getApplications(rowsPerPage, page = 1) {
    const skipNum = (page - 1) * rowsPerPage;
    if (this.state.filter) {
      var params = this.state.filter;
      params.skip = skipNum;
      params.top = rowsPerPage;
    } else {
      var params = { skip: skipNum, top: rowsPerPage };
    }

    const modifiedParams = { ...params };

    //convert the dates to UTC before sending to server.
    if (modifiedParams.fromDate && modifiedParams.toDate) {
      var fromDateToconvert = moment(params.fromDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      var toDateToconvert = moment(params.toDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      modifiedParams.fromDate = moment.utc(moment(fromDateToconvert)).format();
      modifiedParams.toDate = moment.utc(moment(toDateToconvert)).format();
    }

    try {
      const response = await axios.get(`/api/applications`, {
        params: modifiedParams,
        headers: {
          Authorization: JSON.parse(localStorage.getItem("userData")).token,
          "Cobrand-Id": this.state.cobrand.id
        }
      });
      return response.data;
    } catch (error) {
      if (
        error.response.data.errorCode &&
        error.response.data.errorCode === "Y800"
      ) {
        this.setState({ noDataAvailable: true });
      }
    }
  }

  handlePageChange = async page => {
    const pageResp = await this.getApplications(this.state.rowsPerPage, page);
    this.setState({ applications: pageResp.application });
  };

  handlePerRowsChange = async (perPage, page) => {
    this.setState({ rowsPerPage: perPage });
    const pageResp = await this.getApplications(perPage, page);
    this.setState({ applications: pageResp.application });
  };

  filter = async (loginName, applicationId, status, fromDate, toDate) => {
    const params = {};
    let searchCriteria = "";
    if (loginName) {
      params.loginName = loginName;
      searchCriteria = "Login Name: " + loginName;
    }
    if (applicationId) {
      params.applicationId = applicationId;
      searchCriteria = searchCriteria + ", ApplicationId: " + applicationId;
    }
    if (status) {
      params.status = status;
      searchCriteria = searchCriteria + ", Status: " + status;
    }
    if (fromDate) {
      params.fromDate = fromDate;
      searchCriteria =
        searchCriteria +
        ", From date: " +
        moment(fromDate).format("MM-DD-YYYY");
    }
    if (toDate) {
      params.toDate = toDate;
      searchCriteria =
        searchCriteria + ", To Date: " + moment(toDate).format("MM-DD-YYYY");
    }

    if (searchCriteria) {
      if (searchCriteria.lastIndexOf(",") > 1) {
        var commaPos = searchCriteria.lastIndexOf(",");
        searchCriteria =
          searchCriteria.substr(0, commaPos) +
          " and " +
          searchCriteria.substr(commaPos + 1, searchCriteria.length);
      }
      if (searchCriteria.indexOf(",") == 0) {
        searchCriteria = searchCriteria.substr(1, searchCriteria.length);
      }

      this.setState({ searchCriteria: "Search results for " + searchCriteria });
    } else {
      let defaultFromDate = moment()
        .subtract(6, "d")
        .format("MM-DD-YYYY");
      let defaultToDate = moment().format("MM-DD-YYYY");
      let searchCriteria =
        "Search results for From date: " +
        defaultFromDate +
        " and To Date: " +
        defaultToDate;
      this.setState({ searchCriteria });
    }

    await this.setState({ filter: params });
    const pageResp = await this.getApplications(this.state.rowsPerPage);
    if (pageResp) {
      this.setState({ noDataAvailable: false });
      this.setState({
        applications: pageResp.application,
        totalCount: pageResp.totalCount
      });
    }

    //trackPromise(
    //axios.get('/api/applications', {
    //params: params,
    //headers: {
    //'Authorization': JSON.parse(localStorage.getItem('userData')).token,
    //'Cobrand-Id': this.state.cobrand.id
    //}
    //})
    //.then(res => {
    //this.setState({ applications: res.data.application, totalCount: res.data.totalCount });
    //this.props.history.replace(this.props.location.pathname, this.state.applications);
    //})
    //.catch(err => {
    //console.log(err);
    //})
    //);
  };

  handleChange = e => {
    this.setState({ searchTerm: e.target.value });
  };

  render() {
    /* Temporary fix for spinner loading */
    return (
      <div className="container main">
        <div className="row mt-4 mb-2">
          <div className="col-md-4 ml-auto">
            <CobrandSelector />
          </div>
        </div>
        <div className="row mt-2 mb-4">
          <div className="col heading">Applications</div>
        </div>

        <Filter filter={this.filter} />

        <div className="mb-1">{this.state.searchCriteria}</div>
        {!this.state.noDataAvailable && (
          <Timezone label="* Times are displayed in" />
        )}
        {this.state.noDataAvailable && (
          <div className="noData">There are no records to display</div>
        )}
        {(!this.state.noDataAvailable && this.state.initialLoaded) && (
          /* Temporary fix for spinner loading */
          <ApplicationsTable
            data={this.state.applications}
            totalCount={this.state.totalCount}
            cobrand={this.state.cobrand}
            paginationPerPage={this.state.rowsPerPage}
            handlePerRowsChange={this.handlePerRowsChange}
            handlePageChange={this.handlePageChange}
          />
        )}
      </div>
    );
  }
}

export default Applications;
